import { render, staticRenderFns } from "./wechat-app-bill-view.vue?vue&type=template&id=0bcde46b&scoped=true&"
import script from "./wechat-app-bill-view.vue?vue&type=script&lang=ts&"
export * from "./wechat-app-bill-view.vue?vue&type=script&lang=ts&"
import style0 from "./wechat-app-bill-view.vue?vue&type=style&index=0&id=0bcde46b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcde46b",
  null
  
)

export default component.exports